import { render, staticRenderFns } from "./Swipe.vue?vue&type=template&id=83b85f98&scoped=true&"
import script from "./Swipe.vue?vue&type=script&lang=js&"
export * from "./Swipe.vue?vue&type=script&lang=js&"
import style0 from "./Swipe.vue?vue&type=style&index=0&id=83b85f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b85f98",
  null
  
)

export default component.exports